/**
 * Demo-session roles for the IAM-disabled mode — dev tooling only.
 *
 * `VITE_IAM_DISABLED=true` (the demo/presentation mode) bypasses the Keycloak
 * login and the SMART gate, but the access profile then has NO roles, so the
 * role-gated shells (`ClinicalWorkspaceGate` / `AdminRouteGuard`) dead-end on
 * "You do not have access". For local verification sessions that is useless:
 * you can boot the app but cannot drive it.
 *
 * `VITE_DEMO_ROLES` (comma-separated, e.g. `attending_physician,tenant_admin`)
 * seeds the role fallback — and is honored ONLY while IAM is disabled. In any
 * real auth mode this returns [] regardless of the env var, so it cannot widen
 * access: real modes take roles from the authenticated profile, and the actual
 * authorization boundary is server-side ABAC/JWT either way (the frontend
 * gates are navigation UX, not security).
 */
import { isIamDisabled } from '../api/marchApiEnv';

export function demoFallbackRoles(): string[] {
  if (!isIamDisabled()) return [];
  const raw = String(import.meta.env.VITE_DEMO_ROLES ?? '').trim();
  if (!raw) return [];
  return raw
    .split(',')
    .map((r) => r.trim())
    .filter(Boolean);
}
